import React from 'react';

import { ReorderButton } from 'craft/containers/FloatingMenu/commons/ReorderButton';
import { useFlow } from 'craft/state';

export const ReorderStepButton = ({
  flowId,
  index,
  direction,
  disabled,
  tooltipPlacement,
}: {
  flowId: string;
  index: number;
  direction: 'left' | 'right';
  disabled: boolean;
  tooltipPlacement: 'top' | 'bottom';
}) => {
  const { onMoveStep } = useFlow(flowId);

  const onMove = () => {
    onMoveStep(index, direction === 'left' ? index - 1 : index + 1);
  };

  return (
    <ReorderButton
      tooltipPlacement={tooltipPlacement}
      direction={direction}
      disabled={disabled}
      onClick={onMove}
    />
  );
};
